import { FunctionComponent, PropsWithChildren } from "react";
import AppMenu from "@/components/common/AppMenu";
import AppMobileMenu from "@/components/common/AppMobileMenu";
import { use100vh } from "react-div-100vh";
import { TrumpetIcon } from "@form/components/common/icons";
import { isMaintenance } from "@/config/config";
import Link from "next/link";
import Image from "next/image";
import ConnectWallet from "@/components/common/ConnectWallet";

const MenuLayout: FunctionComponent<PropsWithChildren> = function ({
  children,
}) {
  const height = use100vh();
  return (
    <div
      className="overflow-hidden flex flex-col"
      style={{
        height: height ? `${height}px` : "100vh",
      }}
    >
      <div
        className="h-[60px] flex-grow-0 flex items-center justify-between backdrop-blur bg-white px-6 sm:px-[60px] text-sm"
        style={{
          filter: "drop-shadow(15px 4px 40px rgba(0, 0, 0, 0.1))",
        }}
      >
        <Link href={"/"}>
          <Image
            src="/airdrop_assets/karatdao4x.png"
            width={150}
            height={40}
            className="-translate-y-1 action"
          ></Image>
        </Link>
        <div className="flex items-center gap-6">
          <ConnectWallet></ConnectWallet>
          <Link href={"/"}>
            <div className="action text-primary font-semibold">Exit app</div>
          </Link>
        </div>
      </div>
      <div className="flex-1 flex flex-col sm:flex-row overflow-hidden">
        <div className="p-3 pr-0 hidden sm:block">
          <AppMenu></AppMenu>
        </div>
        <div className="block sm:hidden">
          <AppMobileMenu></AppMobileMenu>
        </div>
        <div className="flex-1 overflow-x-hidden">
          {isMaintenance && (
            <div className="mt-3 mx-5 sm:mx-[7vw] flex items-center justify-center bg-bg_brown mb-2 font-bold rounded-lg p-4">
              <TrumpetIcon className="mr-2"></TrumpetIcon>
              {process.env.NEXT_PUBLIC_MAINTENANCE_MESSAGE}
            </div>
          )}
          <div>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default MenuLayout;
